import { createVatReport } from './createVatReport'
import { getAllVatReports } from './getAllVatReports'
import { getVatReport } from './getVatReport'

export const vatReports = [createVatReport, getAllVatReports, getVatReport]
